import api from '../libs/axios';

export const getRewardList = async (params, signal) => {
  const response = await api.get('/reward', { params, signal });
  return response.data;
};

export const redeemReward = async (dto, signal) => {
  const response = await api.post('/company/redeem/reward', dto, { signal });
  return response.data;
};

export const deleteReward = async (params, signal) => {
  const response = await api.delete('/reward', { params, signal });
  return response.data;
};

export const updateReward = async (params, dto, signal) => {
  const response = await api.patch('/reward', dto, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    params,
    signal,
  });
  return response.data;
};
